import React, { useEffect, useState } from "react";
import { apiRequest } from "../api";
import ReactQuill from "react-quill-new"; // Import ReactQuill
import 'react-quill-new/dist/quill.snow.css';

const AddTemplateModal = ({ template, onClose, onSave }) => {
    const [name, setName] = useState("");
    const [subject, setSubject] = useState("");
    const [cc_email, setCc] = useState("");
    const [html, setHtml] = useState(""); // HTML content state
    const [isDefault, setIsDefault] = useState(false); // State for default checkbox
    const [feedbackMessage, setFeedbackMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false); // Loading state
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem("token"); // Get token from localStorage
    const universityId = localStorage.getItem("universityId");


    //Editor Options start
    const modules = {
    toolbar: [
      [{ 'header': [1, 2, false] }],
      ['bold', 'italic', 'underline','strike', 'blockquote'],
      [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
      ['link', 'image'],
      ['clean']
    ],
  };

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image'
  ];
    //Editor Options end

    useEffect(() => {
        if (template) {

            setName(template.name);
            setSubject(template.subject);
            setCc(template.email_cc);
            setHtml(template.html_content || ""); // Set HTML content if available
            setIsDefault(template.is_default || false); // Set default value if available
        } else {
            setName("");
            setSubject("Event Follow up");
            setCc("");
            setHtml("");
            setIsDefault(false);
        }
    }, [template]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true); // Set loading state
        const payload = {
            name,
            university_id: universityId,
            subject: subject,
            email_cc: cc_email,
            html_content: html || null, // Include HTML content
            is_default: isDefault, // Include the is_default flag
        };
        console.log(payload)
        const url = template
            ? `${apiUrl}/templates/${template.id}` // Edit mode
            : `${apiUrl}/templates/${universityId}`; // Add mode
        const method = template ? "PUT" : "POST";

        try {
            const data = await apiRequest(url, method, payload, token);
            console.log(`Email Template ${template ? "updated" : "added"} successfully`, data);
            setFeedbackMessage(`Email Template ${template ? "updated" : "added"} successfully!`);
            setTimeout(() => {
                setFeedbackMessage(null);
                setIsLoading(false); // Reset loading state
                onSave(); // Notify parent to refresh list
                onClose(); // Close the modal
            }, 2000);
        } catch (error) {
            setIsLoading(false); // Reset loading state
            setFeedbackMessage(`Failed to ${template ? "update" : "add"} Email Template. Please try again.`);
        }
    };

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    backgroundColor: "#fff",
                    padding: "20px",
                    borderRadius: "5px",
                    width: "600px",
                    maxHeight: "90vh",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <h4 style={{ marginBottom: "20px", flexShrink: 0 }}>
                    {template ? "Edit Template" : "Add New Template"}
                </h4>
                <div style={{ flex: 1, overflowY: "auto", minHeight: 0 }}>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Template Name:</label>
                            <input
                                type="text"
                                className="form-control"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                                disabled={isLoading}
                            />
                        </div>
                        <div className="form-group">
                            <label>Subject:</label>
                            <input
                                type="text"
                                className="form-control"
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                                disabled={isLoading}
                            />
                        </div>
                        <div className="form-group">
                            <label>Email Address to CC [Optional]:</label>
                            <input
                                type="text"
                                className="form-control"
                                value={cc_email}
                                placeholder="email@email.com"
                                onChange={(e) => setCc(e.target.value)}
                                disabled={isLoading}
                            />
                        </div>
                        <div className="form-group">
                            <label>Content:</label>
                            <ReactQuill
                                value={html}
                                onChange={setHtml}
                                readOnly={isLoading}
                                theme="snow"
                                modules={modules}
                                formats={formats}
                                placeholder="Enter email template content here..."
                            />
                        </div>
                        <div className="form-group">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={isDefault}
                                    onChange={(e) => setIsDefault(e.target.checked)}
                                    disabled={isLoading}
                                />
                                &nbsp; Set as Default Template
                            </label>
                        </div>
                    </form>
                </div>
                <div className="modal-footer" style={{ flexShrink: 0, marginTop: "20px" }}>
                    <button
                        type="button"
                        className="btn btn-primary"
                        disabled={isLoading}
                        onClick={handleSubmit}
                    >
                        {isLoading ? "Submitting..." : template ? "Update" : "Save"}
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={onClose}
                        disabled={isLoading}
                    >
                        Cancel
                    </button>
                </div>
                {feedbackMessage && (
                    <p
                        style={{
                            marginTop: "10px",
                            color:
                                feedbackMessage.includes("successfully")
                                    ? "green"
                                    : "red",
                            flexShrink: 0,
                        }}
                    >
                        {feedbackMessage}
                    </p>
                )}
            </div>
        </div>
    );
};

export default AddTemplateModal;